import { Component, Input, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import {  takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ApiServicesService } from '../../services/api-services.service';

@Component({
  selector: 'app-documents-checklist',
  templateUrl: './documents-checklist.component.html',
  styleUrls: ['./documents-checklist.component.scss'],
  encapsulation: ViewEncapsulation.None // Disable encapsulation
})
export class DocumentsChecklistComponent implements OnInit {

  observableSubscription$ = new Subject();
  beneficiaryId: any;
  isFBUser: any;

  constructor(    
    private toastr: ToastrService,
    public dialog: MatDialog,    
    private apiService: ApiServicesService
  ) {
    this.beneficiaryId = sessionStorage.getItem('beneficiaryId');
    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
  }
  
  ngOnInit() {
    
  }

  deleteDocumentHandler(item) {
    this.apiService.deleteFileFromDocumentList(this.beneficiaryId, item.fileCategory.group, item.fileCategory.code, item.id).pipe(takeUntil(this.observableSubscription$)).subscribe((data: any) => {      
      this.toastr.success(data.message, 'Success');
    });
  }

}
